import { render, staticRenderFns } from "./DepositOrBorrowTokenWindow.vue?vue&type=template&id=87277b86&"
import script from "./DepositOrBorrowTokenWindow.vue?vue&type=script&lang=js&"
export * from "./DepositOrBorrowTokenWindow.vue?vue&type=script&lang=js&"
import style0 from "./DepositOrBorrowTokenWindow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports